import { render, staticRenderFns } from "./RiskScenarioEditForm.vue?vue&type=template&id=5cd682e6&"
import script from "./RiskScenarioEditForm.vue?vue&type=script&lang=js&"
export * from "./RiskScenarioEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports